import React from 'react';
import { Box, Link, HStack, Image, Text, Tooltip } from '@chakra-ui/react';
import { FaSpotify, FaMusic, FaUser, FaCompactDisc } from 'react-icons/fa';

interface SpotifyAttributionProps {
  playbackState: any;
}

/**
 * SpotifyAttribution component displays links back to Spotify for the current track,
 * artist, and album as required by Spotify's Design Guidelines.
 */
const SpotifyAttribution: React.FC<SpotifyAttributionProps> = ({ playbackState }) => {
  if (!playbackState?.item) return null;

  const trackUrl = playbackState.item.external_urls?.spotify;
  const artistUrl = playbackState.item.artists?.[0]?.external_urls?.spotify;
  const albumUrl = playbackState.item.album?.external_urls?.spotify;

  if (!trackUrl && !artistUrl && !albumUrl) return null;

  return (
    <Box 
      position="absolute" 
      bottom="0" 
      left="0" 
      right="0" 
      p={2} 
      bg="rgba(0, 0, 0, 0.7)"
      backdropFilter="blur(5px)"
      zIndex={10}
    >
      <HStack spacing={3} justifyContent="center" alignItems="center">
        <Image 
          src="/images/spotify-logo.png" 
          alt="Spotify" 
          height="20px"
          mr={1}
        />
        
        {trackUrl && (
          <Tooltip label="Open track in Spotify">
            <Link 
              href={trackUrl} 
              isExternal 
              color="#1DB954" 
              fontSize="xs" 
              display="flex" 
              alignItems="center"
              _hover={{ textDecoration: 'none', color: 'white' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaMusic size={12} style={{ marginRight: '4px' }} />
              <Text as="span">Track</Text>
            </Link>
          </Tooltip>
        )}
        
        {artistUrl && (
          <Tooltip label="Open artist in Spotify">
            <Link 
              href={artistUrl} 
              isExternal 
              color="#1DB954" 
              fontSize="xs" 
              display="flex" 
              alignItems="center"
              _hover={{ textDecoration: 'none', color: 'white' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaUser size={12} style={{ marginRight: '4px' }} />
              <Text as="span">Artist</Text>
            </Link>
          </Tooltip>
        )}
        
        {albumUrl && (
          <Tooltip label="Open album in Spotify">
            <Link 
              href={albumUrl} 
              isExternal 
              color="#1DB954" 
              fontSize="xs" 
              display="flex" 
              alignItems="center"
              _hover={{ textDecoration: 'none', color: 'white' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaCompactDisc size={12} style={{ marginRight: '4px' }} />
              <Text as="span">Album</Text>
            </Link>
          </Tooltip>
        )}
      </HStack>
    </Box>
  );
};

export default SpotifyAttribution; 